equalheight=function(t){var i,e=0,h=0,r=new Array;$(t).each(function(){if(i=$(this),$(i).height("auto"),topPostion=i.position().top,h!=topPostion){for(currentDiv=0;currentDiv<r.length;currentDiv++)r[currentDiv].height(e);r.length=0,h=topPostion,e=i.height(),r.push(i)}else r.push(i),e=e<i.height()?i.height():e;for(currentDiv=0;currentDiv<r.length;currentDiv++)r[currentDiv].height(e)})};

/* accordion.js */

function getAccordion(element_id,screen) 
{
    //$(window).resize(function () { location.reload(); });

  if ($(window).width() < screen) 
  {
    var concat = '';
    obj_tabs = $( element_id + " li" ).toArray();
    obj_cont = $( ".tab-content .tab-pane" ).toArray();
    jQuery.each( obj_tabs, function( n, val ) 
    {
      concat += '<div id="' + n + '" class="panel panel-default">';
      concat += '<div class="panel-heading" role="tab" id="heading' + n + '">';
      concat += '<h4 class="panel-title"><a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapse' + n + '" aria-expanded="false" aria-controls="collapse' + n + '">' + val.innerText + '</a></h4>';
      concat += '</div>';
      concat += '<div id="collapse' + n + '" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading' + n + '">';
      concat += '<div class="panel-body">' + obj_cont[n].innerHTML + '</div>';
      concat += '</div>';
      concat += '</div>';
    });
    $("#accordion").html(concat);
    $("#accordion").find('.panel-collapse:first').addClass("in");
    $("#accordion").find('.panel-title a:first').attr("aria-expanded","true");
    $(element_id).remove();
    $(".tab-content").remove();
  } 
}

$(document).ready(function() {
  equalheight('.equal p');
    equalheight('.smpl .simple-tips h3');
  equalheight('.sngl .single-product .single-txt');
    equalheight('.aff-box .support-inn');

  getAccordion("#tabsnew",768);

  $('.index-testimonial-carousel').owlCarousel({
    loop : true,
    margin : 10,
    dots: true,
    nav : false,
    responsiveClass : true,
    responsive : {
      0 : {
        items : 1,
        nav : false
      },
      600 : {
        items : 2,
        nav : false
      },
      1000 : {
        items : 3,
        nav : false,
        loop : false,
      }
    }
  });
  
    $('.product-single__thumbnails').owlCarousel({
    loop : false,
    margin : 10,
    dots: false,
    nav : true,
    responsiveClass : true,
    responsive : {
      0 : {
        items : 1,
        nav : true
      },
      600 : {
        items : 1,
        nav : true
      },
      768 : {
        items : 4,
        nav : true
      },
      1000 : {
        items : 4,
        nav : true,
        loop : false,
      }
    }
  });
  
  
  /*=============================================== combo product section start ==============================*/
  
  jQuery('input[name=product_conditioner]:checked').each(function(i){
     var selValue = jQuery(this).data('prodid');  console.log(selValue);
     var prod_title = jQuery('#prod_title_'+selValue).val();      
     var prod_price = jQuery('#prod_price_'+selValue).val();
     if(selValue){
       jQuery('.goto-checkout .order-summary .order-sumtxt').append('<p class="prod-ord-sum" id="prod-ordr-summary-'+selValue+'">'+prod_title +': <strong>'+ prod_price+'</strong></p>');
     }
  });
  
  jQuery('input[name=product_conditioner]').on('change', function() {
      var selValue = jQuery(this).data('prodid');  
      var prod_title = jQuery('#prod_title_'+selValue).val();      
      var prod_price = jQuery('#prod_price_'+selValue).val();      
            
      if(jQuery(this).is(':checked')){
        jQuery('#summary-'+selValue+' .order-sumtxt').append('<p class="prod-ord-sum" id="prod-ordr-summary-'+selValue+'">'+prod_title +': <strong>'+ prod_price+'</strong></p>');
        jQuery('#single-product-'+selValue).parent().addClass('active');
        jQuery('.goto-checkout .order-summary .order-sumtxt').append('<p class="prod-ord-sum" id="prod-ordr-summary-'+selValue+'">'+prod_title +': <strong>'+ prod_price+'</strong></p>');
      }
      else{
        jQuery('#summary-'+selValue+' .order-sumtxt #prod-ordr-summary-'+selValue).remove();        
        jQuery('#single-product-'+selValue).parent().removeClass('active');
        jQuery('.goto-checkout .order-summary .order-sumtxt #prod-ordr-summary-'+selValue).remove();
      }     
  });
  
  jQuery('#addtocart_btn').click(function(){ 
     var valuesProArr = [];
     
    jQuery('.product_conditioner:checked').each(function(i){
     var selValue1 = jQuery(this).val(); 
     if(selValue1){
       valuesProArr.push(selValue1);
     }
    });
     
     
     if( valuesProArr.length > 0 ){  
       var countcartO;
       var updates = "";
       for(countcartO=0; valuesProArr.length > countcartO; countcartO++){
         if(countcartO == 0){
           updates ="updates["+valuesProArr[countcartO]+"]=1";
         }else{
           updates =updates+"&"+"updates["+valuesProArr[countcartO]+"]=1";
         }
         
       }     

      jQuery.ajax({
        type: 'POST',                             
        url: '/cart/update.js',
        dataType: 'json',                               
        data: updates,            
        success: function(data){  
            window.location.href = '/cart';
        }                           
      });     

      return false;  
     }else{ 
       alert('Please choose any one product.');
       return false;
     }
    });
  
  jQuery('.grid-add-to-cart').click(function(){
    var prodid = jQuery(this).data('prodid'); 
    var updates = "updates["+prodid+"]=1";
    jQuery.ajax({
      type: 'POST',                             
      url: '/cart/update.js',
      dataType: 'json',                               
      data: updates,            
      success: function(data){  
        window.location.href = "/checkout";
      }                           
    });     

    return false;
  });
  
  jQuery('.list-add-to-cart').click(function(){
    var prodid = jQuery(this).data('prodid'); 
    var updates = "updates["+prodid+"]=1";
    jQuery.ajax({
      type: 'POST',                             
      url: '/cart/update.js',
      dataType: 'json',                               
      data: updates,            
      success: function(data){  
        window.location.href = "/cart";
      }                           
    });     

    return false;
  });
  
  /*=============================================== combo product section end =================================*/
  
    
    
   /* if($('.more-ingredient .ingredient-row').find('.ingredient-col').length > 4) {
      var obj = $('.ingredient-more-btn');
      obj.append('<a class="prod-bttn" href="javascript:void(0)">VIEW MORE</a>');
    }
    var i = 0;
    $('.more-ingredient .ingredient-row').find('.ingredient-col').each(function(){
      if(i >= 4) {
        $(this).css('display','none');
      }
      i++;
    }); */

  /*$('.ingredient-more-btn .prod-bttn').on('click',function() {
    $(this).parent().prev('.ingredient-row').children('.ingredient-col:gt(3)').slideToggle('fast');
    $(this).text($(this).text() == 'VIEW MORE' ? 'Show less' : 'VIEW MORE');
  });*/
  
  $('.powerful-ingred').hide();
  $('.ingredient-col').hide();
  
  jQuery('.ingredient-sec #tabsnew li a').each(function(i){
    if($(this).hasClass('active')){
      var handle = $(this).data('handle');
      $('.ingredient-'+handle).show(); 
    }
  });
  
  $('.ingredient-sec #tabsnew li a').on('click',function() {
    var handle = $(this).data('handle');
    $('.powerful-ingred').hide();
    $('.ingredient-col').hide();
    $('.ingredient-'+handle).show();    
  });
  
  
});

$(window).resize(function(){
  
  equalheight('.equal p');
  equalheight('.smpl .simple-tips h2');
  equalheight('.sngl .single-product .single-txt');
  equalheight('.aff-box .support-inn');
  
  if ($(window).width() > 1100){
    $('.testi-sec,.faq-sec').parallax("50%", 0.2);
  }
})
.trigger('resize');


function jqUpdateSize(){  
  $(document).scroll(function(){
    var top = $(window).scrollTop(); 
    if(top > 300){
      jQuery(".header-section header").sticky({topSpacing:0,zIndex:9999});    
    }else{
      $(".header-section header").unstick();
    }
  });                   
}

jQuery(document).ready(jqUpdateSize); // When the page first loads 
jQuery(window).resize(jqUpdateSize); // When the browser changes size    


function openNav() {
    document.getElementById("mySidenav").style.width = "250px";
}

function closeNav() {
    document.getElementById("mySidenav").style.width = "0";
}

$('.single-prohdr').click(function(){     
    $(this).find('.product_conditioner').trigger('click');
});

  $('.snglinpt').click(function(){     
    $(this).find('.product_conditioner').trigger('click');
  });

  let blackFridayBanner = document.querySelectorAll(".blackFridayBanner");
let normalBanner = document.querySelectorAll(".normalBanner");
let date = new Date()
let currentDate = date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate();
console.log("something is going");
console.log(blackFridayBanner,"blackFridayBanner");
console.log(normalBanner,"normalBanner");

if (currentDate == "2021-11-26" || currentDate == "2021-11-27" || currentDate == "2021-11-28" || currentDate == "2021-11-29"){
	blackFridayBanner.forEach((el)=>{
		el.style.display = "block";
	})
	normalBanner.forEach((el)=>{
		el.style.display = "none";
	})
} else{
	blackFridayBanner.forEach((el)=>{
		el.style.display = "none";
	})
	normalBanner.forEach((el)=>{
		el.style.display = "block";
	})
}